import React from 'react';
import { NOTIFICATION_PLACEMENT } from '../../components/common/notifications/notifications.constants';
import FixedNotifications from '../../components/fixed-notifications/fixed-notifications';
import FixedSidebar from '../../components/fixed-sidebar/fixed-sidebar';
import { MainHeader } from '../../components/header/main-header/main-header';
import { SessionChecker } from '../../components/session-checker/session-checker';
import { NotificationsContainer } from '../../containers/notifications/notifications';
import { OperationPanelContainer } from '../../features/operation-panel/operation-panel.container';
import { SidebarContainer } from '../../features/sidebar/sidebar';
import styles from './user.scss';

interface Props {
  children: any;
}

const UserLayout = ({ children }: Props) => {
  return (
    <div className="ltr">
      <SessionChecker />

      <FixedNotifications>
        <NotificationsContainer placement={NOTIFICATION_PLACEMENT.GLOBAL} />
      </FixedNotifications>

      <MainHeader />

      <FixedSidebar>
        <SidebarContainer />
      </FixedSidebar>

      <div className={styles.userContent}>{children}</div>

      <OperationPanelContainer />
    </div>
  );
};

export default UserLayout;
